<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
 						<h4 class="mb-3 card-ttl">ロール許可</h4>	
						<div class="loading"  v-show="loading">受信中...</div>
						<div class="el-table__body-wrapper table-responsive">
							
							<div class="form-group">
								
							   <label>ロール名</label>
							   <div class="form-row">
                               <label class="label label-success">{{ roleInfo.name }}</label>
							   </div>
                              </div>

							<div class="form-group">
								
							   <label>許可</label>
							   <div class="form-row">
                               <label v-for="(permission,key) in permissionData" :key="key" class="label label-success">{{ permission.label_jp }},</label>
							   </div>
							  </div>

							<div class="btn-wrap form-group text-center">
								<a class="btn btn-primary" href="/roles/">戻る</a>
								<button class="delete-btn btn btn-primary" @click="doDelete(roleInfo.id)" v-show="permission_list['role-delete'] ? true:false" >削除</button>
									<confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                  			</div>

						</div>	
					</div>
                </div>
            </div>
			
		</div>
	</div>
</template>

<script>
import ConfirmDialogue from './ConfirmDialogue.vue'
export default {
  	components: {
    	ConfirmDialogue
    },
	props: ['roleData', 'rolePermission'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			permissionData: {},
			siteId:0,
			roleInfo:{}
			
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
		this.permissionData = JSON.parse(this.rolePermission)
		this.roleInfo = JSON.parse(this.roleData)
	},

	methods: {
		 async doDelete(id) {
			console.log("id:"+id)
            var confirmDialog = this.$refs.confirmDialogue;
			console.log(confirmDialog)
			console.log(confirmDialog.show)
            const ok = await confirmDialog.show({
                title: 'ロールを削除',
                message: 'ロールを削除しますか？',
                okButton: 'はい',
                cancelButton: 'いいえ'
            })
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            try {
              if (ok) {
                  this.deleteRole(id);
              } 
            }
            catch(error){

            }
		},
		deleteRole(id) {
          this.loading = true;
      this.errors = {};
      this.error = false;
      axios.post('/roles/' + id , {
		  '_method':'DELETE',
      		id:id
      	}).then(response => {
        this.loading = false;
        //this.info = response.data.info;
         this.categories = response.data.result;
         this.$toast("削除しました", {
            //timeout: false,
            toastClassName: "toaster"
        });
        //this.id = response.data.result.id;
      }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
          //this.info = error.response.data.info;
          this.$toast(error.response.data.info, {
			toastClassName: "toaster error"
          })
          this.error = true;
           this.loading = false;
        } else if (error.response.status === 419) {
          alert("ページセッション切りましたので、削除できませんでした。ページをリロードしてください")
        }
      });
        }
		
	}

}
</script>

<style scoped>

.label-success {
	margin: 5px;
	padding: 2px 5px;
	/*color: #fff;
	background-color: #536dfe;*/
	
}
</style>